import React, { useState, useEffect } from 'react';
import { Label, Input, CheckMark } from './style.js';

function Checkbox(_a) {
    var name = _a.name, value = _a.value, _b = _a.defaultChecked, defaultChecked = _b === void 0 ? false : _b, onUpdate = _a.onUpdate, children = _a.children, _c = _a.disabled, disabled = _c === void 0 ? false : _c, style = _a.style;
    var _d = useState(defaultChecked), isChecked = _d[0], setIsChecked = _d[1];
    useEffect(function () {
        setIsChecked(defaultChecked);
    }, [defaultChecked]);
    var handleChange = function (event) {
        setIsChecked(!isChecked);
        if (onUpdate)
            onUpdate({
                name: event.target.name,
                value: event.target.value,
                label: children,
                checked: !isChecked,
            });
    };
    return (React.createElement(Label, { disabled: disabled, "data-testid": name + "-label", style: style },
        children,
        React.createElement(Input, { name: name, value: value, type: "checkbox", onClick: handleChange, defaultChecked: defaultChecked, disabled: disabled }),
        React.createElement(CheckMark, { "data-testid": "checkmark", isChecked: isChecked },
            React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", focusable: "false", "data-prefix": "fas", "data-icon": "check", className: "svg-inline--fa fa-check fa-w-16", role: "img", viewBox: "0 0 512 512" },
                React.createElement("path", { fill: "currentColor", d: "M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z" })))));
}

export { Checkbox as default };
